import React from 'react';
import './testimonials.css';
// import Swiper core and required modules
import { Pagination} from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

const data = [
    {
        avatar: "https://i.ibb.co/pr6FPWb/avatar1.jpg",
        name: 'Tina Snow',
        review: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Explicabo corrupti dolores tenetur enim molestiae voluptate quas, deleniti laborum ad exercitationem beatae nihil soluta temporibus mollitia amet aliquam velit doloremque et!'
    },
    {
        avatar: "https://i.ibb.co/0sZg1fD/avatar2.jpg",
        name: 'Tina Snow 2',
        review: 'Ipsum dolor sit, amet consectetur adipisicing elit. Explicabo corrupti dolores tenetur enim molestiae voluptate quas, deleniti laborum ad exercitationem beatae nihil soluta temporibus mollitia amet aliquam velit et!'
    },
    {
        avatar: "https://i.ibb.co/v1zVCrV/avatar3.jpg",
        name: 'Tina Snow 3',
        review: 'Dolor sit, amet consectetur adipisicing elit. Explicabo corrupti dolores tenetur enim molestiae voluptate quas, deleniti laborum ad exercitationem beatae temporibus mollitia amet aliquam velit doloremque et!'
    },
    {
        avatar: "https://i.ibb.co/PxqsyWf/avatar4.jpg",
        name: 'Tina Snow 4',
        review: 'Sit, amet consectetur adipisicing elit. Explicabo corrupti dolores tenetur enim voluptate quas, deleniti laborum ad exercitationem beatae nihil soluta temporibus mollitia amet aliquam velit doloremque et!'
    }
]


const Testimonials = () => {
    return (
        <section id='testimonials'>
            <h5>Review from clients</h5>
            <h2>Testimonials</h2>

            <Swiper className="container testimonials__container"
            // install Swiper modules
            modules={[Pagination]}
            spaceBetween={40}
            slidesPerView={1}
            pagination={{ clickable: true }}
            >
                {
                    data.map(({avatar, name, review}, index) =>{
                        return(
                            <SwiperSlide key={index} className="testimonial">
                                <div className="client__avatar">
                                    <img src={avatar} alt="Avatar 1" />
                                </div>
                                <h5 className='client__name'>{name}</h5>
                                    <small className='client__review'>{review}</small>
                            </SwiperSlide>
                        )
                    })
                }
            </Swiper>
        </section>
    );
};

export default Testimonials;